module.exports = __webpack_public_path__ + "66bdfcb15ae799496ecc86ac4a0c251e.pdf";